let chatConfig = {
	sfDomain: 'https://vizio--full.sandbox.my.salesforce.com',
	sfSiteDomain: 'https://vizio--full.sandbox.my.site.com/',
	baseToken: '00DDc0000001PR3',
	deploymentTitle: 'VIZIO_Account_Embedded_Chat',
	baseLiveAgentContentURL: 'https://c.la2-c1cs-ia6.salesforceliveagent.com/content',
	deploymentId: '5721P000000L3Sm',
	buttonId: '5731P000000L3x0',
	baseLiveAgentURL: 'https://d.la2-c1cs-ia6.salesforceliveagent.com/chat',
	eswLiveAgentDevName: 'EmbeddedServiceLiveAgent_Parent04I1P0000004CALUA2_18ab8f47b99',
	isOfflineSupportEnabled: false,
	sfScriptSrc: 'https://vizio--full.sandbox.my.salesforce.com/embeddedservice/5.0/esw.min.js',
	sfScriptDomain: 'https://service.force.com'
};

if (window.location.href.includes('www.vizio.com')) {
	chatConfig = {
		...chatConfig,
		sfDomain: 'https://vizio.my.salesforce.com',
		sfSiteDomain: 'https://vizio.my.site.com',
		baseToken: '00D1a000000KFTF',
		baseLiveAgentContentURL: 'https://c.la2-c1-ph2.salesforceliveagent.com/content',
		deploymentId: '5721P000000L3Sm',
		buttonId: '5731P000000L3x0',
		baseLiveAgentURL: 'https://d.la2-c1-ph2.salesforceliveagent.com/chat',
		eswLiveAgentDevName: 'EmbeddedServiceLiveAgent_Parent04I1P0000004CALUA2_18ab8f47b99',
		sfScriptSrc: 'https://vizio.my.salesforce.com/embeddedservice/5.0/esw.min.js'
	};
}

export const sfChatConfig = chatConfig;
